// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1jcpN","header":"ReportDetails_header__w7-LM","title":"ReportDetails_title__PyAKG","left":"ReportDetails_left__3RuQr"};